export const selectOptionsLoanProductType = [
  "DSCR",
  "Fix and Flip",
  "Ground Up Construction",
  "Stabilized Bridge",
  "Other",
  // "Foreclosure Bail Out",
  // "Vacant Land",
];
